<template>
  <div id="video_photo" class="relativeItem">
    <!--头像区域-->
    <div class="head flex-box relativeItem">
      <img :src="info.avatar" class="headimg imgBlock" />
      <div class="text">
        <p class="p1">{{ info.nickname }}</p>
        <p class="p2 flex-box">
          <i class="age boy">
            {{ info.age }}
          </i>
          <img
            :src="info.network_wealth_level_img"
            class="imgBlock"
            v-if="info.network_wealth_level_img != ''"
          />
        </p>
      </div>
      <span id="photo1" class="commonBk absoluteItem centerY">关注</span>
    </div>
    <p class="photo-text">{{ info.gxqm }}</p>

    <!--图片区域-->
    <ul class="flex-box photos relativeItem" :class="{ single: photo_list.length == 1 }">
      <span class="allA" id="photo3"></span>
      <li class="relativeItem overHidden" v-for="(n, index) in photo_list" :key="index">
        <img :src="n" class="imgBlock absoluteItem centerImg" />
      </li>
    </ul>

    <!--底部点赞显示-->
    <div class="bottomtext" id="photo2">
      <span>{{ info.zancount }}</span>
      <span>{{ info.commentcount }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "video_photo",
  components: {},
  props: ["v_info", "list"],
  data() {
    return {
      photo_list: [{}],
      info: [], //动态信息
    };
  },
  methods: {
    /**openinstall相关事务 */
    open_install_thing() {
      /*web页面向app传递的json数据(json string/js Object)，应用被拉起或是首次安装时，通过相应的android/ios api可以获取此数据*/
      // eslint-disable-next-line
      var data = OpenInstall.parseUrlParams(); //openinstall.js中提供的工具函数，解析url中的所有查询参数
      // eslint-disable-next-line
      new OpenInstall(
        {
          /*appKey必选参数，openinstall平台为每个应用分配的ID*/
          appKey: "tj3x4l",
          /*openinstall初始化完成的回调函数，可选*/
          onready: function () {
            var m = this,
              button2 = document.getElementById("photo1"),
              button3 = document.getElementById("photo2"),
              button4 = document.getElementById("photo3");
            /*在app已安装的情况尝试拉起app*/
            m.schemeWakeup();
            /*用户点击某个按钮时(假定按钮id为downloadButton)，安装app*/
            button2.onclick = function () {
              m.wakeupOrInstall();
              return false;
            };
            button3.onclick = function () {
              m.wakeupOrInstall();
              return false;
            };
            button4.onclick = function () {
              m.wakeupOrInstall();
              return false;
            };
          },
        },
        data
      );
    },

    /**获取动态 */
    get_photo() {
      let _this = this;
      let data = {
        live_id: this.$route.query.live_id,
        is_web: 1,
      };
      this.$jsonp(this.$apis("video_share_photo"), data, (res) => {
        _this.info = res.data.data;
        _this.photo_list = _this.info.imgs;
        _this.$tool.setTitle(`${_this.info.nickname}的广场动态`);
        setTimeout(() => {
          _this.open_install_thing();
        }, 3000);
      });
    },
  },
  mounted: function () {
    this.get_photo();
  },
};
</script>

<style scoped>
#video_photo {
  padding-bottom: 30px;
}
/**头像区域 */
.head {
  align-items: center;
  padding: 15px;
  padding-bottom: 10px;
}
.headimg {
  width: 3.875rem;
  height: 3.875rem;
  margin-right: 14px;
  border-radius: 50%;
}
.text .p1 {
  font-size: 15px;
  font-weight: bold;
  color: #ff5e57;
  margin-bottom: 7px;
}
.text .p2 {
  align-items: center;
}
.text .p2 img {
  max-width: 40px;
}
.text .p2 i {
  display: inline-block;
  font-style: normal;
  font-size: 10px;
  border-radius: 3rem;
  padding: 2px 5px;
  padding-left: 15px;
  color: #fff;
  margin-right: 4px;
}
.text .p2 .girl {
  background: url("../../assets/share/video_share(1).png") 4px center no-repeat #ff549b;
  background-size: 9px;
}
.text .p2 .boy {
  background: url("../../assets/share/video_share(4).png") 4px center no-repeat #3eaeff;
  background-size: 9px;
}
.head span {
  display: block;
  font-size: 12px;
  color: #fff;
  padding: 5px 0;
  text-align: center;
  width: 15%;
  right: 15px;
  border-radius: 3rem;
}
.photo-text {
  padding: 0 15px;
  font-size: 15px;
  color: #333;
  text-align: justify;
}

/**图片区域 */
.photos {
  padding: 10px 15px;
  padding-bottom: 5px;
  flex-wrap: wrap;
}
.photos li {
  width: 7rem;
  height: 7rem;
  margin-right: 3px;
  border-radius: 8px;
  margin-bottom: 3px;
}
.photos li:nth-child(3n) {
  margin-right: 0;
}
.photos li img {
  z-index: 0;
  width: 100%;
}
.single li {
  width: 10.75rem;
  height: 10.75rem;
}
.allA {
  z-index: 2;
}

/**底部点赞数量显示 */
.bottomtext {
  padding: 3px 15px;
  font-size: 12px;
  color: #666;
}
.bottomtext span {
  padding: 4px 0;
  padding-left: 25px;
  margin-right: 11%;
}
.bottomtext span:nth-child(1) {
  background: url("../../assets/share/video_share(3).png") left center no-repeat;
  background-size: 18px;
}
.bottomtext span:nth-child(2) {
  background: url("../../assets/share/video_share(2).png") left center no-repeat;
  background-size: 18px;
}
</style>
